import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class PatrolService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	getById(id, callback) {
		const url = `/patrols-app/api/patrols/${id}`;
		this._restClient.exec_get(url, callback);
	}

	getByEventId(eventId, callback) {
		const url = `/patrols-app/api/patrols/byEventId/${eventId}`;
		this._restClient.exec_get(url, callback);
	}

	assignResource(id, resourceId, callback) {
		const url = `/patrols-app/api/patrols/${id}/resource/${resourceId}`;
		this._restClient.exec_post(url, null, callback);
	}

	startPatrol(id, callback) {
		const url = `/patrols-app/api/patrols/${id}/start`;
		this._restClient.exec_post(url, null, callback);
	}

	completePatrol(id, callback) {
		const url = `/patrols-app/api/patrols/${id}/complete`;
		this._restClient.exec_post(url, null, callback);
	}

	completeCheckpoint(id, checkpointId, callback) {
		const url = `/patrols-app/api/patrols/${id}/checkpoints/${checkpointId}/complete`;
		this._restClient.exec_post(url, null, callback);
	}

	streamPatrols(eventId, callback) {
		const args = {
			eventId: eventId
		};

		return this._rc.subscribe("patrols-app", "/patrols", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	delete(id, callback) {
		const url = `/patrols-app/api/patrols/${id}`;
		this._restClient.exec_delete(url, callback);
	}

	getAppConfig(configKey, callback) {
		const url = `/patrols-app/api/patrols/getAppConfig?key=${encodeURIComponent(configKey)}`;
		this._restClient.exec_get(url, callback);
	}
}
